module.exports = __webpack_public_path__ + "static/media/IMG_4432a.0585d3dc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/roraima/IMG_4432a.JPG
// module id = 117
// module chunks = 0